import React from 'react';

export const View = () => null;

function dateKey(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

export default function BootstrapScheduler({
    dataSource = [],
    currentView = 'month',
    currentDate = new Date(),
    startDateExpr = 'startDate',
    textExpr = 'text',
    onCurrentDateChange,
    onAppointmentRendered,
    height,
}) {
    const baseDate = new Date(currentDate || new Date());
    const visible = dataSource.filter((item) => {
        const date = new Date(item?.[startDateExpr]);
        if (Number.isNaN(date.getTime())) return false;
        if (currentView === 'day') return dateKey(date) === dateKey(baseDate);
        if (currentView === 'week') {
            const start = new Date(baseDate);
            start.setDate(start.getDate() - ((start.getDay() + 6) % 7));
            start.setHours(0, 0, 0, 0);
            const end = new Date(start);
            end.setDate(end.getDate() + 7);
            return date >= start && date < end;
        }
        return date.getFullYear() === baseDate.getFullYear() && date.getMonth() === baseDate.getMonth();
    }).sort((left, right) => new Date(left?.[startDateExpr]) - new Date(right?.[startDateExpr]));

    const move = (direction) => {
        const next = new Date(baseDate);
        if (currentView === 'day') next.setDate(next.getDate() + direction);
        else if (currentView === 'week') next.setDate(next.getDate() + (7 * direction));
        else next.setMonth(next.getMonth() + direction);
        onCurrentDateChange?.(next);
    };

    return (
        <div className="border rounded bg-white" style={{ height, overflow: 'auto' }}>
            <div className="d-flex align-items-center justify-content-between gap-2 p-2 border-bottom sticky-top bg-light">
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => move(-1)}>Önceki</button>
                <strong>{baseDate.toLocaleDateString('tr-TR', {
                    ...(currentView === 'day' ? { day: '2-digit' } : {}),
                    month: 'long',
                    year: 'numeric',
                })}</strong>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => move(1)}>Sonraki</button>
            </div>
            <div className="d-grid gap-2 p-2">
                {visible.map((item, index) => {
                    const date = new Date(item?.[startDateExpr]);
                    const renderedRef = (element) => {
                        if (element) onAppointmentRendered?.({ appointmentData: item, appointmentElement: element });
                    };
                    return (
                        <div key={item.CI_REF || index} ref={renderedRef} className="rounded text-white p-2"
                            style={{ background: item.CI_ISL_TAR ? '#4caf50' : '#1976d2' }}>
                            <div className="fw-bold">{item?.[textExpr] || 'İşlem'}</div>
                            <small>{date.toLocaleString('tr-TR')}</small>
                        </div>
                    );
                })}
                {visible.length === 0 && <div className="text-muted text-center p-4">Kayıt yok</div>}
            </div>
        </div>
    );
}
